<template>
  <v-card
    class="rounded-lg"
  >
    <slot name="header" />

    <v-card-text :class="contentClass">
      <apexchart
        id="scatter-chart"
        type="scatter"
        class="w-100"
        :height="height"
        :options="chartOptions"
        :series="series"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { ApexChartsLocale } from '@/data/models/ApexchartsLocale'
import i18n from '@/plugins/i18n'

export default {
  name: 'ScatterChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    series: {
      type: Array,
      required: true
    },
    hideLabels: {
      type: Boolean,
      default: false
    },
    colors: {
      type: Array,
      default: () => ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0']
    },
    height: {
      type: String,
      default: '350'
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String,
      default: null
    },
    xaxis: {
      type: Object,
      default: () => ({
        labels: {
          show: true
        }
      })
    },
    yaxis: {
      type: Object,
      default: () => ({})
    },
    annotations: {
      type: Object,
      default: () => ({})
    },
    fill: {
      type: Object,
      default: () => ({
        opacity: 0.5
      })
    },
    markers: {
      type: Object,
      default: () => ({})
    },
    tooltip: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    colorss() {
      return this.$vuetify.theme.secondary
    },
    chartOptions() {
      return {
        colors: this.colors,
        chart: {
          height: this.height,
          toolbar: {
            show: false
          },
          type: 'scatter',
          locales: ApexChartsLocale,
          defaultLocale: i18n.locale,
          zoom: {
            enabled: false
          },
          selection: {
            enabled: false
          },
          events: {
            beforeZoom: function() {
              return false
            },
            beforeScroll: function() {
              return false
            }
          }
        },
        xaxis: this.xaxis,
        yaxis: this.yaxis,
        fill: this.fill,
        dataLabels: {
          enabled: false
        },
        annotations: this.annotations,
        markers: this.markers,
        tooltip: this.tooltip
      }
    }
  }
}
</script>
